import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Card, ListGroup } from 'react-bootstrap';
import { FaUsersCog, FaTags, FaNewspaper, FaLock } from 'react-icons/fa';

const AdminNavigation = () => {
  const authState = useSelector(state => state.authStore);
  const isAdmin = authState?.user?.role?.includes('Admin');

  if (!isAdmin) {
    return null;
  }

  return (
    <Card className="shadow-sm mb-4">
      <Card.Header className="bg-primary text-white">
        <FaLock className="me-2" />
        <span className="fw-bold">Admin İşlemleri</span>
      </Card.Header>
      <ListGroup variant="flush">
        <ListGroup.Item as={Link} to="/admin/role-management" className="d-flex align-items-center">
          <FaUsersCog className="me-2 text-primary" />
          Rol Yönetimi
        </ListGroup.Item>
        <ListGroup.Item as={Link} to="/admin/tags" className="d-flex align-items-center">
          <FaTags className="me-2 text-primary" />
          Etiket Yönetimi
        </ListGroup.Item>
        <ListGroup.Item as={Link} to="/admin/news" className="d-flex align-items-center">
          <FaNewspaper className="me-2 text-primary" />
          Haber Yönetimi
        </ListGroup.Item>
      </ListGroup>
    </Card>
  );
};

export default AdminNavigation;
